import React, { useCallback } from 'react';
import { CommissioningFilter } from '@search/vtbeco-frontend-core/view/filters/models/Filter';
import { Checkbox, PlainSelect } from '@vtblife/uikit';

import classname from '@search/classname/src';
import { Commissioning, Quarter } from '@search/filter-enums/enums';

import './CommissioningDateFilter.css';
import { quarters } from '@search/helpers/src/quarters';

interface ICommissioningFilter {
    filter: CommissioningFilter;
    handleChange: (value: CommissioningFilter) => void;
    classNameGroup?: string;
    isMobile?: boolean;
}

const options = [
    {
        value: Commissioning.UNKNOWN,
        text: 'Любой'
    },
    {
        value: Commissioning.COMMISSIONED,
        text: 'Сдан'
    },
    {
        value: Commissioning.IN_PROGRESS,
        text: 'Строится'
    },
    ...quarters()
        .map(({ quarter, year }) => ({
            value: `${Quarter[quarter]}_${year}`,
            text: `До ${quarter} кв. ${year}`
        }))
];

const cn = classname.bind(null, 'CommissioningDateFilter');

export const CommissioningDateFilter: React.FC<ICommissioningFilter> = ({
    filter,
    handleChange,
    classNameGroup,
    isMobile = false
}) => {
    const onCheckboxChange = (value: boolean, status: Commissioning) => {
        if (value) {
            handleChange(new CommissioningFilter(status));
        } else {
            handleChange(new CommissioningFilter(Commissioning.UNKNOWN));
        }
    };

    const handleSelectChange = useCallback(
        (val: string) => {
            handleChange(new CommissioningFilter(val));
        },
        [ handleChange ]
    );

    return (
        <div className={cn(null, { classNameGroup, isMobile })}>
            <PlainSelect
                value={filter.commissioning}
                options={options}
                size='s'
                onChange={handleSelectChange}
            >
                Срок сдачи
            </PlainSelect>
            <div className={cn('nbButtons')}
            >
                <Checkbox
                    name='Done'
                    value={filter.commissioning === Commissioning.COMMISSIONED}
                    onChange={(value) => onCheckboxChange(value, Commissioning.COMMISSIONED)}
                    variant='filter'
                    block
                >
                    Сдан
                </Checkbox>
                <Checkbox
                    name='Progress'
                    value={filter.commissioning === Commissioning.IN_PROGRESS}
                    onChange={(value) => onCheckboxChange(value, Commissioning.IN_PROGRESS)}
                    variant='filter'
                    block
                >
                    Строится
                </Checkbox>
            </div>
        </div>
    );
};
